import '../../common/bn-property';
import '../../common/bn-surface';
import '../../common/bn-loading';
import '../../work-orders/actions/assign-installer-button';
import '../../work-orders/actions/unassign-button';
import './bin-path-name';
import { entityStore } from '~/utility/BinSentry-ui-utility';
import { LitEntity, html, css } from '../../utility/lit-entity';
import { sharedStyles } from '../../styles/shared-styles';
import { bannerStyles } from '../../styles/banner-styles';
import { StoreMixin } from '../../utility/store-mixin';
import { formatDateShort, getDateFromString } from '../../utility/dates';

class BinWorkOrderList extends StoreMixin(LitEntity) {
  static get properties() {
    return {
      workOrders: { type: Array, attribute: false },
      canInspectWorkOrder: { type: Boolean, attribute: false },
    };
  }

  static get styles() {
    return [sharedStyles, bannerStyles, css`
      .container {
        display: flex;
        gap: 1rem;
        flex-direction: column;
        margin: 1rem;
      }
      .bin-name {
        display: inline-block;
        margin-bottom: .5em;
        font-weight: bold;
      }
      .heading {
        color: var(--gray-60);
      }
      .properties {
        display: grid;
        grid-template-columns: 1fr 1fr 1fr 1fr 2fr 1fr 1fr 1fr;
        gap: 1rem;
        border-bottom: 1px solid var(--gray-40);
        padding-bottom: 1rem;
      }
      .properties a {
        display: flex;
        align-self: center;
        margin-left: auto;
      }
      bn-property {
        margin: 0 2em 0 0;
        flex-grow: 1;
      }
      .actions {
        float: right;
        margin-bottom: .5em;
        white-space: nowrap;
      }
      .no-data {
        margin: 2em 8px;
        text-align: center;
      }
      .item label {
        display: none;
      }
      @media(max-width: 1000px) {
        .properties {
          grid-template-columns: 1fr;
        }
        bn-property + bn-property {
          margin: 1em 0 0 0;
        }
        .header {
          display: none;
        }
        .item label {
          display: inline-block;
          margin-right: 1ch;
        }
        .item label::after {
          content: ':';
        }
      }
    `];
  }

  render() {
    if (this.loading) {
      return html`<bn-loading></bn-loading>`;
    }

    if (!this.workOrders || !this.workOrders.length) {
      return html`
        <div class="no-data">
          <p>There are no Work Orders to display.</p>
        </div>
      `;
    }

    return html`
      <div class="container">
        ${this._renderHeader()}
        ${this.workOrders.map((item) => this._renderItem(item))}
      </div>
    `;
  }

  _renderHeader() {
    return html`
      <div class="properties header">
        <span class="heading">Reference ID</span>
        <span class="heading">Created</span>
        <span class="heading">Type</span>
        <span class="heading">State</span>
        <span class="heading">Pre-Diagnosis</span>
        <span class="heading">Scheduled</span>
        <span class="heading">Completed</span>
      </div>
    `;
  }

  _renderItem(workOrder) {
    const { createdAt, requestType, state, preDiagnosis, scheduledFor, completedAt } = workOrder.properties;
    const scheduledText = scheduledFor ? formatDateShort(getDateFromString(scheduledFor)) : 'Not Scheduled';
    const completedText = completedAt ? formatDateShort(completedAt) : 'Not Completed';

    return html`
      <div class="properties item">
        <span class="property">
          <label>Reference ID</label>
          ${this._renderReferenceId(workOrder)}
        </span>
        <span class="property">
          <label>Created</label>
          ${formatDateShort(createdAt)}
        </span>
        <span class="property">
          <label>Type</label>
          ${requestType}
        </span>
        <span class="property">
          <label>State</label>
          ${state}
        </span>
        <span class="property">
          <label>Pre-Diagnosis</label>
          ${preDiagnosis}
        </span>
        <span class="property">
          <label>Scheduled For</label>
          ${scheduledText}
        </span>
        <span class="property">
          <label>Completed At</label>
          ${completedText}
        </span>
      </div>
    `;
  }

  _renderReferenceId(workOrder) {
    const { referenceId } = workOrder.properties;
    const workOrderHref = workOrder.getLinkByRel('self').href;
    if (this.canInspectWorkOrder) {
      return html`
        <a href="/work-order-admin/show?workOrderId=${workOrderHref}">
          <button class="button button--text">
            ${referenceId}
          </button>
        </a>
      `;
    }
    return html`${referenceId}`;
  }

  _reload() {
    entityStore.invalidateHref(this.href);
  }

  _entityChanged(entity) {
    super._entityChanged(entity);
    if (!this.entity) {
      return;
    }
    this.workOrders = this.entity.getSubEntitiesByClass('work-order');
  }

  _stateChanged({ organizationType }) {
    this.canInspectWorkOrder = ['service-account', 'service-partner', 'binsentry'].includes(organizationType);
  }
}

customElements.define('bin-work-order-list', BinWorkOrderList);
